module.exports = __webpack_public_path__ + "static/media/hero_simple-celebration-01.1f4a54d0.wav";